export const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const calcNights = (checkIn, checkOut) => {
  const start = toDate(checkIn);
  const end = toDate(checkOut);
  if (!start || !end) return 0;
  const startUtc = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
  const endUtc = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
  const diff = Math.round((endUtc - startUtc) / 86400000);
  return diff > 0 ? diff : 0;
};

export const formatShortDate = (value, fallback = '-') => {
  const date = toDate(value);
  if (!date) return fallback;
  try {
    return new Intl.DateTimeFormat('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(date);
  } catch (_) {
    return date.toISOString().slice(0, 10);
  }
};

export const formatDateRange = (start, end) => {
  if (!start && !end) return 'Select dates';
  if (start && !end) return `${formatShortDate(start)} - ...`;
  if (!start && end) return formatShortDate(end);
  return `${formatShortDate(start)} - ${formatShortDate(end)}`;
};

export const formatGuests = (guests) => {
  const count = Number(guests || 0);
  if (!Number.isFinite(count) || count <= 0) return 'Guests';
  return `${count} guest${count === 1 ? '' : 's'}`;
};

export const formatMoney = (value, currency = 'INR', options = {}) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '-';
  const { currency: overrideCurrency, ...rest } = options || {};
  const effectiveCurrency = overrideCurrency || currency || 'INR';
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: effectiveCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      ...rest,
    }).format(amount);
  } catch (_) {
    return `${effectiveCurrency} ${amount.toLocaleString('en-IN', rest)}`;
  }
};

export const formatInr = (value, currencyOrOptions = {}, maybeOptions = {}) => {
  if (typeof currencyOrOptions === 'string') {
    return formatMoney(value, currencyOrOptions, maybeOptions);
  }
  return formatMoney(value, 'INR', currencyOrOptions || {});
};
